import '../scss/main.scss';
import Header from './Header.svelte'; // var page = document.querySelector('.main');
// var container = document.createElement('div');
// container.className = 'qi-header scroll-sticky-container';
// page.insertBefore(container, page.firstChild);
// // turn off page spacer on load
// document
//   .querySelector('.special-report-article-container .story-content-container')
//   .classList.add('loaded');

new Header({
  target: document.querySelector('.masthead'),
  props: {
    headline: document.querySelector('h2.title').innerText,
    dek: document.querySelector('.dek-container').innerText
  }
});